import { useReducer } from 'react';

import { IAction } from 'src/utils/ts-utilities';

export enum StepEnum {
  INITIAL = 'initial',
  SEND_CODE = 'send_code',
  RESET = 'reset',
  CONFIRMATION = 'confirmation',
}

type IActionReducer =
  | IAction<StepEnum.INITIAL>
  | IAction<StepEnum.SEND_CODE, { email: string }>
  | IAction<StepEnum.RESET>
  | IAction<StepEnum.CONFIRMATION>;

interface IState {
  activeStep: StepEnum;
  email: string;
}

const initialState: IState = {
  activeStep: StepEnum.INITIAL,
  email: '',
};

const reducer = (state: IState, action: IActionReducer): IState => {
  switch (action.type) {
    case StepEnum.SEND_CODE:
      return {
        ...state,
        email: action.payload.email,
        activeStep: StepEnum.RESET,
      };
    case StepEnum.RESET:
      return {
        ...state,
        activeStep: StepEnum.CONFIRMATION,
      };
    case StepEnum.CONFIRMATION:
      return {
        ...state,
        email: '',
        activeStep: StepEnum.INITIAL,
      };
    default:
      return state;
  }
};

export const useForgotPasswordSlice = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const sendCode = (email: string) => {
    dispatch({
      type: StepEnum.SEND_CODE,
      payload: {
        email,
      },
    });
  };

  const reset = () =>
    dispatch({
      type: StepEnum.RESET,
      payload: {},
    });

  return { state, sendCode, reset };
};
